import React from 'react';
import { useSelector } from 'react-redux';
import DayPageShell from './DayPageShell';
import PatternQuizGame from '../PatternQuizGame';
import { s3PublicUrl } from '../../../utils/s3PublicUrl';

export default function Day7({ onStageComplete }) {
  const themeData = useSelector((state) => state.theme.data);
  const stage7 = themeData?.stages_data?.stage_7;
  const questions = stage7?.questions;
  const badgeUrl = s3PublicUrl(stage7?.badge);
  const pointsIconUrl = s3PublicUrl(themeData?.points_icon);
  const correctPoints = themeData?.correct_points ?? 0;
  const dayBonusPoints = themeData?.bonus_points ?? 0;

  const hasValidQuestions =
    Array.isArray(questions) &&
    questions.length > 0 &&
    questions.some(
      (q) =>
        String(q?.question ?? '').trim().length > 0 &&
        String(q?.answer ?? '').trim().length > 0
    );
  const isConfigured = !!stage7 && hasValidQuestions;

  return (
    <DayPageShell dayNumber={7} className="main-day-view--immersive">
      {!isConfigured ? (
        <p className="main-day-subtitle">
          Stage is not configured: add question and answer entries in stage_7
          questions in the theme.
        </p>
      ) : (
        <PatternQuizGame
          questions={questions}
          rules={stage7.rules}
          badgeUrl={badgeUrl}
          badgeTitle={String(stage7?.title ?? stage7?.name ?? 'Day 7')}
          questionImage={String(stage7?.question_image ?? '')}
          didYouKnowImage={String(stage7?.did_you_know_image ?? '')}
          questionTextWrapClassName="day-question-panel__text-wrap--day7"
          correctPoints={correctPoints}
          dayBonusPoints={dayBonusPoints}
          pointsIconUrl={pointsIconUrl}
          badgeFallbackLabel="Day 7"
          onComplete={onStageComplete}
        />
      )}
    </DayPageShell>
  );
}
